// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/kitchen-sink/diagnosis-list/diagnosis-list.less
// module id = 3477
// module chunks = 0